import type { ReactNode } from 'react';
import { Box, Card, Heading, Paragraph } from '@zillow/constellation-10';

type Props = {
  title: string;
  description?: string;
  children: ReactNode;
};

export function DocumentGroup({ title, description, children }: Props) {
  return (
    <Card
      elevated={false}
      body={
        <Box css={{ display: 'flex', flexDirection: 'column', gap: 'loose' }}>
          <Box>
            <Heading level={3} textStyle="heading-xs" css={{ overflowWrap: 'anywhere' }}>
              {title}
            </Heading>
            {description && (
              <Paragraph textStyle="body-sm" color="text.subtle">
                {description}
              </Paragraph>
            )}
          </Box>
          {children}
        </Box>
      }
    />
  );
}
